import { mapPagingToRecordInfo } from './authHelpers';

const SORT_BY_FROM_LEGACY = {
    1: 'CREATED_DATE',
    2: 'SEND_DATE',
    3: 'SUBJECT',
    4: 'SUBJECT',
};

export function mapBlastSearchSortParams({ sortBy, sort }) {
    const numeric = typeof sortBy === 'number' ? sortBy : parseInt(sortBy, 10);
    const resolvedSortBy =
        SORT_BY_FROM_LEGACY[numeric] ||
        (typeof sortBy === 'string' ? sortBy : 'CREATED_DATE');
    let sortDirection = 'DESC';
    if (sort === 1 || sort === 'asc' || sort === 'ascend') {
        sortDirection = 'ASC';
    } else if (sort === 2 || sort === 'desc' || sort === 'descend') {
        sortDirection = 'DESC';
    }
    return { sortBy: resolvedSortBy, sortDirection };
}

export function resolveBlastTypeParam(messageType) {
    const normalized =
        typeof messageType === 'string'
            ? messageType.toUpperCase()
            : messageType;
    if (normalized === 1 || normalized === '1' || normalized === 'EMAIL') {
        return 'EMAIL';
    }
    if (normalized === 2 || normalized === '2' || normalized === 'SMS') {
        return 'SMS';
    }
    return undefined;
}

function blastTypeLabel(type) {
    if (type === 'EMAIL' || type === 1 || type === '1') {
        return 'Email';
    }
    if (type === 'SMS' || type === 2 || type === '2') {
        return 'SMS';
    }
    if (type === 'Email' || type === 'SMS') {
        return type;
    }
    return type != null ? String(type) : '';
}

function blastTypeFormValue(type) {
    const label = blastTypeLabel(type);
    if (label === 'Email') {
        return 1;
    }
    if (label === 'SMS') {
        return 2;
    }
    return type;
}

export function mapBlastListRow(row) {
    if (!row) {
        return row;
    }
    const type = row.type != null ? row.type : row.messageType;
    return {
        ...row,
        messageType: blastTypeLabel(type),
        deliveryStatus: row.state != null ? row.state : row.deliveryStatus,
        status: row.state != null ? row.state : row.status,
    };
}

export function legacyBlastSearchPayload(data) {
    const rows = Array.isArray(data.body) ? data.body.map(mapBlastListRow) : [];
    const paging = data.paging || data.pagination || data.pageInfo || null;
    const mappedInfo = mapPagingToRecordInfo(paging);
    if ((mappedInfo.totalRecords === 0 || !mappedInfo.totalRecords) && rows.length > 0) {
        mappedInfo.totalRecords = rows.length;
    }
    if (!mappedInfo.nrecords || mappedInfo.nrecords <= 0) {
        mappedInfo.nrecords = 10;
    }
    return {
        messageBlast: rows,
        recordInfo: mappedInfo,
    };
}

export function mapMembersToReceivers(members, messageType) {
    const isEmail =
        messageType === 1 ||
        messageType === '1' ||
        messageType === 'EMAIL' ||
        messageType === 'Email';
    return (members || []).map((m) => {
        const receiver = {
            name: m.nameReceiver != null ? m.nameReceiver : m.name,
        };
        if (isEmail) {
            receiver.email = m.emailAddress != null ? m.emailAddress : m.email;
        } else {
            receiver.mobileNumber =
                m.mobileNumber != null ? m.mobileNumber : m.mobile;
        }
        return receiver;
    });
}

export function mapReceiverRow(row, blastType) {
    if (!row) {
        return row;
    }
    const isEmail = blastTypeLabel(blastType) === 'Email';
    return {
        name: row.name,
        email: isEmail ? row.email : row.emailAddress,
        mobileNumber: isEmail ? row.mobileNumber : row.mobileNumber,
        status: row.status,
    };
}

export function legacyBlastViewPayload(detailBody, receiverRows, receiverPaging) {
    const body = detailBody || {};
    const type = body.type != null ? body.type : body.messageType;
    const receivers = Array.isArray(receiverRows) ? receiverRows : [];
    return {
        ...body,
        messageBlastId: body.messageBlastId,
        subject: body.subject,
        content: body.content,
        sendDate: body.sendDate,
        sender: body.sender,
        createdBy: body.createdBy,
        createdDate: body.createdDate,
        messageType: blastTypeLabel(type),
        deliveryStatus: body.state != null ? body.state : body.deliveryStatus,
        receivers: {
            dataReceivers: receivers.map((r) => mapReceiverRow(r, type)),
            recordInfo: mapPagingToRecordInfo(receiverPaging),
        },
    };
}

export function legacyBlastDetailForForm(detailBody) {
    const legacy = legacyBlastViewPayload(detailBody, [], null);
    return {
        ...legacy,
        messageType: blastTypeFormValue(detailBody && detailBody.type),
    };
}
